import {setContext} from 'apollo-link-context'
import {UI_VERSION} from '@/config'

const isServer = typeof window === 'undefined'

export default ({getToken}) =>
  setContext((_, {headers}) => {
    const token = getToken()
    return {
      headers: {
        ...headers,
        ...(isServer && {
          'User-Agent': `web - ${UI_VERSION}`
        }),
        authorization: token ? `Token ${token}` : ''
      }
    }
  })
